<template>
  <v-container width="80%">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Search Transction</div>
        <div>
          <bread-crumb :bread-crumbs="['Hold Transactions']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="">
        <v-card-text class="mb-3">
          <v-card-text class="pb-0">
            <v-row row-gutters class="mt-1">
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  placeholder="Beneficiary Name"
                  outlined
                  dense
                  clearable
                  v-model="filterData.beneficiary_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  placeholder="Transaction ID"
                  outlined
                  dense
                  clearable
                  v-model="filterData.pin_number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  attach
                  :items="[
                    {
                      text: 'Hold',
                      value: {
                        status: 2,
                        stage: 2,
                      },
                    },
                    {
                      text: 'Compliance Hold',
                      value: {
                        status: 2,
                        stage: 4,
                      },
                    },
                    {
                      text: 'Post',
                      value: {
                        status: 5,
                        stage: null,
                      },
                    },
                    {
                      text: 'Paid',
                      value: {
                        status: 6,
                        stage: null,
                      },
                    },
                  ]"
                  placeholder="Transaction status"
                  outlined
                  min-height="35px"
                  dense
                  clearable
                  v-model="filterData.txn_status"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  type="date"
                  label="From Transaction Date"
                  outlined
                  dense
                  clearable
                  v-model="filterData.from_date"
                ></v-text-field>
              </v-col>

              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  type="date"
                  label="To Transaction Date"
                  outlined
                  dense
                  clearable
                  v-model="filterData.to_date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12" class="d-flex">
                <v-btn
                  depressed
                  class="primary text-capitalize"
                  @click="getHoldTransactions()"
                  small
                  >Get Results</v-btn
                >
                <v-btn
                  depressed
                  class="mx-2 primary text-capitalize"
                  small
                  @click="clear()"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-row>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="mt-2 ms-1"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter values."
              hide-details
              dense
              single-line
              clearable
              class="mt-2"
            ></v-text-field
          ></v-row>
        </v-card-text>

        <v-data-table
          dense
          :loading="loader"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="holdTxnlist"
          class=""
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              depressed
              outlined
              small
              color="green"
              class="text-capitalize"
              @click="openPopup(item)"
              >Release<v-icon x-small class="ms-2"
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip rounded small color="primary" block outlined>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.transaction_id="{ item }">
            <a class="border-d" @click="viewTxn(item)">{{
              item.transaction_id
            }}</a>
          </template>
          <template v-slot:item.bank_receipt="{ item }">
            <v-img
              v-if="item.bank_receipt"
              class="ml-1"
              max-height="40"
              max-width="50"
              :src="item.bank_receipt"
              @click="handleImageViewer(item.bank_receipt, '')"
            />
          </template>
        </v-data-table>
      </div>
      <v-dialog persistent v-model="showPopup" max-width="500px">
        <OverlayPageVue :showOverlay="loader" />
        <v-card>
          <v-toolbar class="ma-0 pa-0" color="secondary" dark flat dense>
            <span>Release Transaction</span>
            <!-- <v-spacer></v-spacer> -->
            <v-spacer></v-spacer>
            <v-icon small @click="closePopup">mdi-close</v-icon>
          </v-toolbar>
          <v-form>
            <!-- <v-divider class="ma-0 pa-0"></v-divider> -->
            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="releaseForm">
                <v-row>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Status </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Status"
                      :items="status_items"
                      :rules="validations.statusRules"
                      v-model="selectedStatus"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required">
                      Release
                    </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Release"
                      :items="release_items"
                      :rules="validations.releaseRules"
                      v-model="selectedReleaseItem"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="my-0"
                    v-if="selectedReleaseItem === 'Others'"
                    ><label class="my-0 labelFontsize required">Remarks</label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      :rules="validations.remarksRules"
                      placeholder="Remarks"
                      v-model="remarks"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-form>

          <v-card-actions class="justify-end">
            <v-btn
              depressed
              outlined
              class="text-capitalize primary--text"
              small
              @click="updateTxnStatus()"
              >Submit</v-btn
            >
            <!-- <v-btn
                  depressed
                  color="error"
                  class="text-capitalize"
                  outlined
                  small
                  @click="updateTxnStatus('Cancel')"
                  >Reject</v-btn
                >
                <v-btn
                  depressed
                  color="warning"
                  class="text-capitalize"
                  outlined
                  small
                  @click="updateTxnStatus('Hold')"
                  >Hold</v-btn
                >
                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  small
                  @click="updateTxnStatus('Success')"
                  >Release</v-btn
                > -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import imageViewer from "@/components/tools/imageViewer.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../utils/OverlayPage.vue";
import AgentService from "@/services/agentService/AgentService";
export default {
  name: "Search Transaction",
  mixins: [alerts],
  data() {
    return {
      showPopup: false,
      imageViewerUrl: null,
      isImageViewer: false,
      showRemarksField: false,
      selectedReleaseItem: null,
      remarks: "",
      valid: false,
      selectedTxn: null,
      search: "",
      selectedStatus: "",
      filterData: {
        pin_number: "",
        beneficiary_name: "",
        txn_status: {
          status: 6,
          stage: null,
        },
        txn_stage: null,
        from_date: new Date().toISOString().substr(0, 10),
        to_date: new Date().toISOString().substr(0, 10),
        skip: 0,
        limit: 2000000,
      },
      headers: [
        // { text: "ID", value: "id", sortable: false },
        { text: "PIN No", value: "transaction_id", sortable: false },
        // { text: "Deposit Type", value: "id", sortable: false },
        { text: "TXN date", value: "send_date", sortable: false },
        { text: "TXN status", value: "status", sortable: false },
        { text: "Payment mode", value: "mode_of_payment", sortable: false },
        { text: "Sender name", value: "sender_name", sortable: false },
        {
          text: "Payout country",
          value: "country",
          sortable: false,
        },
        {
          text: "Beneficiary name",
          value: "beneficiary_name",
          sortable: false,
        },
        {
          text: "Receiving agent",
          value: "receiving_partner",
          sortable: false,
        },

        {
          text: "Receiving amount",
          value: "receiving_amount",
          sortable: false,
        },
        { text: "Remarks", value: "remarks", sortable: false },
      ],
      holdTxnlist: [],
      release_items: [],
      status_items: ["Processing", "Paid", "Cancel", "Hold", "Success"],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Required"],
        statusRules: [(v) => !!v || "Required"],
      },
      loader: false,
    };
  },
  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },
  mounted() {},
  watch: {},
  methods: {
    async downloadExcelsheet() {
      if (this.holdTxnlist) {
        this.exportToExcel(this.headers, this.holdTxnlist, "holdTxn_list");
      }
    },
    viewTxn(item) {
      this.$router.push({
        name: "Hold Details",
        query: { id: item.id, login_id: item.login_id, from: "hold" },
      });
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url, val) {
      if (val === "showImage") {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      } else {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      }
    },
    Imageview(file) {
      const imageurl = URL.createObjectURL(file);
      this.suspectFileUrl = imageurl;
    },

    async getHoldTransactions() {
      this.loader = true;
      const filterDataParams = {};
      Object.assign(filterDataParams, this.filterData);
      if (
        this.filterData.txn_status.status &&
        this.filterData.txn_status.stage
      ) {
        filterDataParams.txn_stage = this.filterData.txn_status.stage;
        filterDataParams.txn_status = this.filterData.txn_status.status;
      } else if (
        this.filterData.txn_status.status &&
        !this.filterData.txn_status.stage
      ) {
        filterDataParams.txn_status = this.filterData.txn_status.status;
        delete filterDataParams["txn_stage"];
      }
      try {
        const responseData = await AgentService.getHoldTxnSummary(
          filterDataParams
        );
        this.loader = false;
        if (responseData && responseData.data.status_code === 200) {
          this.holdTxnlist = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("getdata", responseData.data.status_code);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    openPopup(item) {
      console.log(item);
      this.selectedTxn = item;
      this.selectedReleaseItem = null;
      this.remarks = item.remarks;
      this.showPopup = true;
    },
    closePopup() {
      // Close the popup
      this.showPopup = false;
      this.selectedReleaseItem = null;
      this.remarks = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
